import { FC, PropsWithChildren } from 'react';

import clsx from 'clsx';

import css from './PageLayout.module.css';

import { WithClassName } from 'v2/types';

interface PageLayoutProps extends WithClassName {
  overflow?: 'auto' | 'hidden';
}

export const PageLayout: FC<PropsWithChildren<PageLayoutProps>> = ({ className, overflow = 'auto', children }) => (
  <section className={clsx(css.pageLayout, overflow === 'hidden' && css.overflowHidden, className)}>{children}</section>
);
